import React from 'react'
import { HeaderContextProps } from './types'

export const HeaderContext = React.createContext<HeaderContextProps | undefined>(undefined)
